import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import 'bootstrap/dist/css/bootstrap.css';
import reportWebVitals from './reportWebVitals';
import App from "./App";
import { AiProvider } from './Context/AiContext';
import "./i18n";

// 1. Importer les éléments de React Query
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

// 2. Créer l'instance du client
const queryClient = new QueryClient();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    {/* 3. Envelopper toute l'application */}
    <QueryClientProvider client={queryClient}>
      <AiProvider>
        <App />
      </AiProvider>
    </QueryClientProvider>
  </React.StrictMode>
);

reportWebVitals();
